import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const ModalParams: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    backdrop: 'static',
    keyboard: false,
    centered: true,
};
